/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit External/view.blocks to change it.
import * as fromDesignTokens from 'Simple/DesignTokens'
import Editor from './Editor/index'
import React from 'react'
import Resources from './Resources/index'
import ResourcesAction from './ResourcesAction/index'
import SendFrom from './SendFrom/index'
import SendTo from './SendTo/index'
import Tools from './Tools/index'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function External({
  children,
  viewPath = "/DesignSystem/CommsThread/Content/MessageTools/External"
  
}) {
let dtSpaceXs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xs'
        })
let dtColorsNeutral200 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.200'
        })
  return (<React.Fragment
>
<div
  data-testid="External.Vertical"
  data-view-path={viewPath}
 style={{'--pb-1-Z24OPAu': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs,'--pr-2-Z24OPAu': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs,'--pl-3-Z24OPAu': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs,'--btc-4-Z24OPAu': dtColorsNeutral200}}
 className={`views-block ${styles.Vertical}`}
>
<Editor
  viewPath={`${viewPath}/Editor`}
/>
<Tools
  viewPath={`${viewPath}/Tools`}
/>
<div
  data-testid="External.Horizontal"
  data-view-path={viewPath}
 className={`views-block ${styles.Horizontal}`}
>
<SendFrom
  viewPath={`${viewPath}/SendFrom`}
/>
<SendTo
  viewPath={`${viewPath}/SendTo`}
/>
<ResourcesAction
  viewPath={`${viewPath}/ResourcesAction`}
/>
</div>
</div>
<Resources
  viewPath={`${viewPath}/Resources`}
/>
{children}
</React.Fragment>)
}